<template>
  <v-menu
    offset-y
    min-width="400"
    max-width="400"
    content-class="rounded-lg elevation-1"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
        class="mr-0 mr-sm-4"
      >
        <v-avatar color="primary" class="kyano-header-avatar" size="35">
          <span class="white--text uppercase">G</span>
        </v-avatar>
      </v-btn>
    </template>

    <v-card width="440" class="kyano-apps-popup pa-3">
      <v-list>
        <v-list-item>
          <v-list-item-avatar height="80" width="80" class="kyano__avatar">
            <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">
              Jesper van der weide
            </v-list-item-title>
            <v-list-item-subtitle>jesper@snelwebcenter.nl</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list>
        <template v-for="(item, index) in items">
          <v-subheader
            v-if="item.header"
            :key="item.header"
            v-text="item.header"
          ></v-subheader>

          <v-divider
            v-else-if="item.divider"
            :key="index"
            :inset="item.inset"
          ></v-divider>

          <v-list-item v-else :key="item.title" :href="item.href">
            <v-list-item-avatar>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-html="item.title"></v-list-item-title>
              <v-list-item-subtitle
                v-html="item.subtitle"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-icon>fal fa-chevron-right</v-icon>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        title: "Mijn Kyano account",
        icon: "fal fa-user",
        href: "/",
      },
      { divider: true, inset: true },
      {
        title: "Instellingen",
        icon: "fal fa-cog",
        href: "/settings",
      },
      { divider: true, inset: true },
      {
        title: "Support",
        icon: "fal fa-question-circle",
        href: "/support",
      },
      { divider: true, inset: true },
      {
        title: "Uitloggen",
        icon: "fal fa-sign-out",
        href: "/login",
      },
    ],
  }),
};
</script>